/**
 * §8 底部 CTA —— cjwf-cta
 *
 * 需求来源：提示词 第1次提交（DEV-124229）；原型 L12354-12464。
 *
 * 注意事项：
 * 1. 两个品牌 logo 是绝对定位的浮标（.cjwf-brand-logo--cj / --worldfirst）。原型用裸像素钉位
 *    （left:200px / right:180px），与 1000px 的内容盒无关联，窄屏会飘到不相干的位置；
 *    已在 index.less 的三端增量里按 D7 改成容器相对定位（left/right: 4%）。
 * 2. WorldFirst logo 原在第三方 CDN（mdn.marmot-cloud.com），已落到公共资源仓 —— 第三方 CDN
 *    不可控、跨境慢，且一旦失效就是品牌方 logo 空白。
 * 3. 【D5 已落定 260818】"Contact Us" 在原型里是 href="#" 占位（点了只会跳回页首），
 *    业务方给定真实目标为 WhatsApp 客服 https://wa.me/15715806890，新窗口打开。
 *    地址集中在 constants 的 LINKS.contact，单测 CASE-L3 逐字断言（含新窗口属性）。
 */
import React from 'react';
import EmphasisText from './EmphasisText';

export default function BottomCta({ data }) {
  if (!data) return null;

  return (
    <section className="cjwf-cta">
      <div className="cjwf-brand-logo cjwf-brand-logo--cj">
        {/* 原型这两个品牌 logo 是 eager 的：它们是绝对定位浮标，lazy 会让首次滚到底时出现空位跳动 */}
        <img src={data.logoCj} alt={data.logoCjAlt} />
      </div>
      <div className="cjwf-brand-logo cjwf-brand-logo--worldfirst">
        <img src={data.logoWf} alt={data.logoWfAlt} />
      </div>

      <div className="cjwf-cta-container">
        <h2 className="cjwf-cta-title">{data.title}</h2>

        {/* 整段一个词条、三处强调，强调词直接内嵌 <strong>（见 index.less 末尾「配色承接」段）。
            顺带解决了原来的一个隐患：以前靠 EmphasisText 拼 Fragment，首尾都是文本节点，而本仓 SSR
            产物会剥掉全部 HTML 注释、React 又靠 `<!-- -->` 分隔相邻文本节点，稍不注意就 hydrate 报
            `Text content did not match`。EmphasisText 会丢弃空片段，保证文本与 <strong> 交替、
            不产生相邻文本节点（判据见单测 CASE-R4）。 */}
        <p className="cjwf-cta-desc">
          <EmphasisText text={data.desc} />
        </p>

        <div className="cjwf-cta-actions">
          <a
            className="cjwf-cta-btn cjwf-cta-btn-primary"
            href={data.primaryUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {data.primaryText}
          </a>
          {/* Contact Us → WhatsApp 客服，新窗口打开（需求 260818）。
              rel="noopener noreferrer" 与主按钮同口径：target="_blank" 会把本页的 window 引用
              交给对端（反向标签劫持），且不加 noreferrer 会把本页地址带进 Referer。 */}
          <a
            className="cjwf-cta-btn cjwf-cta-btn-secondary"
            href={data.secondaryUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {data.secondaryText}
          </a>
        </div>
      </div>
    </section>
  );
}
